/**
 * PURPOSE: Cliente de la tabla acumulada nueva (FTR-0065, flag "Tabla acumulada (nueva)" de la categoría).
 * RESPONSIBILITIES: Leer la tabla calculada (con el estado de la guardada), pedir el recálculo en el servidor
 *   (posiciones → acumulada) y guardar el orden manual de un empate perfecto. El backend decide permisos y valida que
 *   los equipos sigan empatados (409 TIE_NOT_FOUND si ya no).
 * COLLABORATORS: httpService.js, area/PosicionesArea/acumulada/AcumuladaStandings.jsx.
 * ROUTE: winscore/src/services/accumulatedStandingsService.js
 */
import httpService from "./httpService.js";

export const ACCUMULATED_STANDINGS_BASE = "/api/hayllis/v2/accumulated-standings";

const scopePath = ({ idevent, idsport }) => `${ACCUMULATED_STANDINGS_BASE}/events/${Number(idevent)}/sports/${Number(idsport)}`;

export const getAccumulatedStandings = async (scope) => {
  const response = await httpService.get(scopePath(scope));
  return response.data?.data;
};

export const recalculateAccumulatedStandings = async (scope) => {
  const response = await httpService.post(`${scopePath(scope)}/recalculate`);
  return response.data?.data;
};

export const saveAccumulatedTieOrder = async ({ idevent, idsport, idparticipants }) => {
  const response = await httpService.put(`${scopePath({ idevent, idsport })}/tie-order`, { idparticipants });
  return response.data?.data;
};

/** Mensaje del sobre V2 de un error de axios (o uno genérico). */
export const accumulatedErrorMessage = (error, fallback) => error?.response?.data?.message || fallback;
